// src/utils/intakePile.js — Document Intake's pile read and the staff-upload sign-in check.
import { supabase } from '../supabase';
import { INTAKE_PILE_OR } from './docVocab';

// uploadFile's error for a refused or missing sign-in: the sign endpoint's 401 reasons (lib/r2auth.js verifyStaff).
export const isSignInRefused = (err) => /not signed in|\b(no_token|invalid_token)\b/.test(err?.message || '');

// One upload link's open pile (not split, still in the Intake pile), oldest first, read in pages of 1,000.
// ⛔ The pile is narrowed IN THE QUERY and paged: one unpaged read of every file the link ever received hit the
// 1,000-row response cap, and the newest files silently never showed (Philip's pile, 1,026 rows, 2026-11-03).
// A failed page returns null — never a partial pile that looks complete.
export async function loadPileFiles(token) {
  const rows = [];
  for (let from = 0; ; from += 1000) {
    const { data, error } = await supabase.from('file_exchange').select('*')
      .eq('upload_token', token).eq('direction', 'client_to_ntrg').is('split_at', null).or(INTAKE_PILE_OR)
      .order('created_at', { ascending: true }).order('id', { ascending: true })
      .range(from, from + 999);
    if (error) { console.error('[intake pile]', token, error.message); return null; }
    rows.push(...data);
    if (data.length < 1000) return rows;
  }
}
